import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/HeroSection.css';
import '../assets/styles/EnhancedHeroSection.css';
import '../assets/styles/Buttons.css';
import '../assets/styles/Highlight.css';
import '../assets/styles/VibeDefinition.css';

const HeroSection: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <h1>
            <span className="highlight">AI-Powered</span> Vibe Trading 
            <br />That Predicts Market Moves
          </h1>
          
          <p className="hero-subtitle">
            Introducing AI Vibe Trading — a next-generation platform with Patented Price on Rails technology 
            that projects potential price movements in real-time, letting you trade on intuition 
            while AI handles the complexities (and automation).
          </p>
          
          <div className="vibe-definition-banner">
            <div className="vibe-definition-content">
              <div className="definition-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20 12H21" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 12H4" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 20V21" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 3V4" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M17.657 17.6569L18.364 18.364" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.63599 5.63605L6.34309 6.34315" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M17.657 6.34315L18.364 5.63605" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.63599 18.364L6.34309 17.6569" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p>
                <strong>What is AI Vibe Trading?</strong> An Agentic AI bot that trades alongside you and interacts with charts using natural language, 
                providing real-time price projections with a documented 78% win rate.
                <span className="patent-badge">Patent Protected</span>
                <span className="investor-badge">AI Agent Technology</span>
              </p>
            </div>
          </div>
          
          <div className="hero-cta">
            <Link to="/demo" className="btn btn-primary btn-large">
              See It In Action
            </Link>
            <Link to="/pricing" className="btn btn-secondary btn-large">
              Start Vibe Trading
            </Link>
          </div>
        </div>
        
        <div className="hero-image">
          <picture>
            {/* WebP version for browsers that support it with responsive sizes */}
            <source 
              type="image/webp"
              sizes="(max-width: 768px) 360px, (max-width: 1024px) 480px, 650px"
              srcSet="/images/optimized/trading-platform-preview-650.webp 650w,
                      /images/optimized/trading-platform-preview-480.webp 480w,
                      /images/optimized/trading-platform-preview-360.webp 360w"
            />
            {/* PNG fallback for browsers that don't support WebP */}
            <source 
              type="image/png"
              sizes="(max-width: 768px) 360px, (max-width: 1024px) 480px, 650px"
              srcSet="/images/optimized/trading-platform-preview-650.png 650w,
                      /images/optimized/trading-platform-preview-480.png 480w,
                      /images/optimized/trading-platform-preview-360.png 360w"
            />
            {/* Original fallback */}
            <img 
              src="/images/trading-platform-preview.png" 
              alt="Translate Stocks Trading Platform with Price on Rails"
              width="650" 
              height="400"
              loading="eager"
              decoding="async"
              style={{
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
          </picture>
          <div className="hero-badge">
            <span className="badge-text">New</span>
            <span className="badge-feature">Agentic Bot</span>
          </div>
        </div>
      </div>
      
      <div className="hero-wave">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="var(--light)" />
              <stop offset="50%" stopColor="#f0eae0" />
              <stop offset="100%" stopColor="var(--light)" />
            </linearGradient>
          </defs>
          <path d="M0 0L60 10C120 20 240 40 360 50C480 60 600 60 720 50C840 40 960 20 1080 15C1200 10 1320 20 1380 25L1440 30V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="url(#waveGradient)"/>
          <path d="M0 0L60 10C120 20 240 40 360 50C480 60 600 60 720 50C840 40 960 20 1080 15C1200 10 1320 20 1380 25L1440 30V30.5L1380 25.5C1320 20.5 1200 10.5 1080 15.5C960 20.5 840 40.5 720 50.5C600 60.5 480 60.5 360 50.5C240 40.5 120 20.5 60 10.5L0 0.5V0Z" fill="rgba(179, 150, 86, 0.15)"/>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
